import { render, staticRenderFns } from "./contactEditDespatchDialog.vue?vue&type=template&id=3d95db10&"
import script from "./contactEditDespatchDialog.vue?vue&type=script&lang=js&"
export * from "./contactEditDespatchDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports